import React, { FC, HTMLAttributes } from 'react';
import styled, { css } from 'styled-components/macro';

import { ColorVariants } from 'theme';
import media from 'helpers/media';

const overlays = {
    light: 0.2,
    medium: 0.5,
    heavy: 0.8,
};

const StyledSection = styled.section<{
    image?: string;
    overlay: number;
    background?: ColorVariants;
    minHeight?: string;
    topMargin?: boolean;
    textCenter?: boolean;
}>`
    width: 100%;
    box-sizing: border-box;
    padding: ${({ theme }) => theme.space.giant} 0;

    ${({ theme }) => media.mobile`
        padding: ${theme.space.large} 0;
    `}

    ${({ image, overlay }) =>
        image &&
        css`
            background-image: ${
                overlay > 0 &&
                css`linear-gradient(rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, ${overlay}) 0%),`
            } url('${image}');
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
        `}

    ${({ minHeight }) =>
        minHeight &&
        css`
            display: flex;
            align-items: center;
            min-height: ${minHeight};
        `}

  ${({ background, theme }) =>
      background &&
      css`
          background-color: ${theme.colors[background]};
      `};

    
    ${({ topMargin }) =>
        topMargin &&
        css`
            margin-top: -65px;
            padding-top: 126px;
            @media screen and (max-width: 1048px) {
                margin-top: -48px;
                padding-top: 80px;
            }
        `}

    ${({ textCenter }) =>
        textCenter &&
        css`
            text-align: center;
        `};
`;

export type SectionProps = {
    /** Name of background colour from YS palette */
    background?: ColorVariants;

    /** Image overlay opacity */
    overlay?: 'light' | 'medium' | 'heavy';

    /** CSS value for minium height */
    minHeight?: string;

    image?: string;

    topMargin?: boolean;

    textCenter?: boolean;
};

const Section: FC<SectionProps & HTMLAttributes<HTMLBaseElement>> = ({
    background,
    overlay,
    minHeight,
    image,
    topMargin,
    textCenter,
    ...rest
}) => {
    return (
        <StyledSection
            {...rest}
            topMargin={topMargin}
            overlay={overlay ? overlays[overlay] : 0}
            minHeight={minHeight}
            image={image}
            background={background}
            textCenter={textCenter}
        >
            {rest.children}
        </StyledSection>
    );
};

export default Section;
